module.exports = __webpack_public_path__ + "img/psych_image.96e3c314.jpg";